<template>
  <div
    class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3"
  >
    <h4 class="mb-0">{{ $t("company_orders.title") }}</h4>
    <div class="d-flex flex-wrap align-items-center gap-2">
      <button
        v-if="waitingCount > 0"
        type="button"
        class="badge pill-attention"
        @click="$emit('toggle:waiting')"
      >
        {{
          $t(
            "company_orders.transactions.awaiting_confirmation",
            { count: waitingCount },
            waitingCount
          )
        }}
      </button>
      <button
        v-if="inProgressCount > 0"
        type="button"
        class="btn btn-link btn-sm text-body-secondary p-0 me-2"
        @click="$emit('toggle:in-progress')"
      >
        {{
          $t("company_orders.transactions.in_progress", {
            count: inProgressCount,
          })
        }}
      </button>
      <template v-if="showBatchActions">
        <button
          v-if="isAdmin"
          type="button"
          class="btn btn-sm btn-success"
          :disabled="isBatchProcessing"
          @click="$emit('confirm:all')"
        >
          <FontAwesomeIcon
            :icon="isBatchProcessing ? 'spinner' : ['far', 'check-double']"
            :class="{ 'fa-spin': isBatchProcessing }"
            class="me-1"
          />
          {{ $t("company_orders.confirm_all") }}
        </button>
        <button
          type="button"
          class="btn btn-sm btn-danger"
          :disabled="isBatchProcessing"
          @click="$emit('reject:all')"
        >
          <FontAwesomeIcon
            :icon="isBatchProcessing ? 'spinner' : ['far', 'circle-xmark']"
            :class="{ 'fa-spin': isBatchProcessing }"
            class="me-1"
          />
          {{ $t("company_orders.reject_all") }}
        </button>
      </template>
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary"
        :disabled="exportDisabled"
        @click="$emit('export')"
      >
        <FontAwesomeIcon :icon="['far', 'download']" class="me-1" />
        {{ $t("company_orders.export_csv") }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  waitingCount: number;
  inProgressCount: number;
  showBatchActions: boolean;
  isAdmin: boolean;
  isBatchProcessing: boolean;
  exportDisabled: boolean;
}>();

defineEmits<{
  "toggle:waiting": [];
  "toggle:in-progress": [];
  "confirm:all": [];
  "reject:all": [];
  export: [];
}>();
</script>
